import LandingKeyboardsPresentation from 'components/LandingKeyboards/LandingKeyboardsPresentation'

export default {
  Presentation: LandingKeyboardsPresentation,
}
